import { Directive, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appFloatingButton]',
  exportAs: 'appFloatingButton'
})
export class FloatingButtonDirective implements OnInit {

  constructor(
    /*private router: Router,*/
  ) {}

  isFixed = false;


  ngOnInit(): void{
    setTimeout(() => {
      if (window.innerHeight < (document.body.clientHeight - 136)){
        this.isFixed = true;
      }else{
        this.isFixed = false;
      }
    }, 500);
    
    // this.router.events.forEach((event) => {
    //   if(event instanceof NavigationEnd) {
    //     setTimeout(() => {
    //       if (window.innerHeight < (document.body.clientHeight - 136)){
    //         this.isFixed = true;
    //       }else{
    //         this.isFixed = false;
    //       }
    //     }, 100);
    //   }
    // });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(_event): void 
  {
    if (window.innerHeight + window.scrollY > (document.body.clientHeight - 136)) { // 136px is the height of the footer
      this.isFixed = false;
    } else {
      this.isFixed = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event): void {
    if (window.innerHeight + window.scrollY > (document.body.clientHeight - 136)) { // 136px is the height of the footer
      this.isFixed = false;
    } else {
      this.isFixed = true;
    }
  }
}
